export const TICKET_ISSUE_CATEGORIES = [
  { key: "damaged_article", label: "Damaged article" },
  { key: "wrong_article", label: "Wrong article" },
  { key: "missing_item", label: "Missing item" },
  { key: "delivery_delay", label: "Delivery delay" },
  { key: "delivery_not_received", label: "Not received" },
  { key: "return_request", label: "Return request" },
  { key: "refund_request", label: "Refund request" },
  { key: "order_status", label: "Order status" },
  { key: "invoice_document", label: "Invoice / document" },
  { key: "product_question", label: "Product question" },
  { key: "general_inquiry", label: "General inquiry" },
  { key: "other", label: "Other" },
];

const CATEGORY_COLORS = {
  damaged_article: "error",
  wrong_article: "warning",
  missing_item: "warning",
  delivery_delay: "info",
  delivery_not_received: "error",
  return_request: "secondary",
  refund_request: "secondary",
  order_status: "default",
  invoice_document: "default",
  product_question: "info",
  general_inquiry: "default",
  other: "default",
};

export function getIssueCategoryLabel(key) {
  if (!key) return null;
  const match = TICKET_ISSUE_CATEGORIES.find((item) => item.key === key);
  return match?.label || key.replace(/_/g, " ");
}

export function getIssueCategoryColor(key) {
  return CATEGORY_COLORS[key] || "default";
}
